export default __webpack_public_path__ + "static/media/Stand_art_pic.ddfdf023.jpg";